<template lang="pug">
  .cuadro-container
    loading(v-if="isLoading")
    info-card(
      v-if="!isLoading"
      :title="o.titulo"
      :number="o.cantidad"
      :iconClass="o.iconClass"
    )
</template>

<script>
import { apiGet } from '../../util/general';
import InfoCard from '../charts/c_info_card';

export default {
  name: 'cantidad_mis_boletas_sin_ver',
  components: {
    'info-card': InfoCard
  },
  data () {
    return {
      o: {
        cantidad:'',
        titulo: 'Mis boletas sin ver',
        iconClass:'fa-pencil'
      },
      isLoading: true
    };
  },
  created () {
    this.fetch();
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      // 2018 tiene 1
      var obj = {
        periodo: new Date().getFullYear()
      }
      apiGet(vm, '/boleta/empleado', obj, function (data) {
        // to do corregir
        const cantidad = data.lista.filter(a => !a.fechaVisto).length
        if (cantidad === 0) {
          vm.$emit('close')
          return
        }
        vm.o.cantidad = cantidad
      }, function (error) {
        console.error('error', error)
      }, function () {
        vm.isLoading = false
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// c_kpi_cantidad_mis_boletas_sin_visualizar.vue?4a9f8f29